import { render, staticRenderFns } from "./SubmitFailureMessage.vue?vue&type=template&id=135f34e7"
import script from "./SubmitFailureMessage.vue?vue&type=script&lang=js"
export * from "./SubmitFailureMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports